import { render, staticRenderFns } from "./ActivateForMale.vue?vue&type=template&id=6559358f&scoped=true"
import script from "./ActivateForMale.vue?vue&type=script&lang=js"
export * from "./ActivateForMale.vue?vue&type=script&lang=js"
import style0 from "./ActivateForMale.vue?vue&type=style&index=0&id=6559358f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6559358f",
  null
  
)

export default component.exports